module.exports = __webpack_public_path__ + "static/media/banner-guide.cf44559b.webp";